import { CircularProgress, Stack, Typography } from '@mui/material';
import { useStripe } from '@stripe/react-stripe-js';
import { GOOGLE_TAG_EVENTS } from 'common/constants.ts';
import { pushToGoogleDataLayer, trackEventFullStory } from 'helpers/utils.ts';
import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import PurchasedInfo from './PurchasedInfo';

export const GENERAL_SUCCESS_MESSAGE = 'Payment completed successfully.';

const PaymentSuccess = () => {
  const [isMicrodeposit, setIsMicrodeposit] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);

  const [searchParams] = useSearchParams();

  const status = searchParams.get('status');
  const paymentIntentClientSecret = searchParams.get('payment_intent_client_secret');

  const stripe = useStripe();

  useEffect(() => {
    if (!stripe || !paymentIntentClientSecret) return;

    stripe
      .retrievePaymentIntent(paymentIntentClientSecret as string)
      .then(({ paymentIntent }) => {
        const isTypeMicrodeposit = paymentIntent?.next_action?.type === 'verify_with_microdeposits';

        setIsMicrodeposit(isTypeMicrodeposit);
      })
      .finally(() => {
        setIsLoaded(true);
      });
  }, [stripe]);

  useEffect(() => {
    if (isLoaded && !isMicrodeposit) {
      // ideally this only happens once (ever), since it's unlikely the user will view the payment complete screen more than once
      pushToGoogleDataLayer({ event: GOOGLE_TAG_EVENTS.PAYMENT_COMPLETE });
      trackEventFullStory(GOOGLE_TAG_EVENTS.PAYMENT_COMPLETE);
    }
  }, [isMicrodeposit, status, isLoaded]);

  if (!isLoaded) return <CircularProgress color="inherit" size={20} />;

  return (
    <Stack alignItems="center" mx={3} mb={3}>
      {!isMicrodeposit && <PurchasedInfo />}

      {isMicrodeposit && (
        <Typography
          sx={{ mt: 2, color: (theme) => theme.palette.customColors.gunMetal }}
          component="span"
          data-test="payment-microdeposit-success-message"
        >
          Please monitor your bank account for the microdeposit over the next 1-2 business days in
          order to complete account verification.
          <br />
          <br />
          Until verification is complete and payment is initiated, coverage is not bound and the
          policy will not be issued.
        </Typography>
      )}
    </Stack>
  );
};

export default PaymentSuccess;
